import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-1"
}

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'primevue/button';

import { useVisibleCalculationItems } from '@/composables/useVisibleCalculationItems';
import { useEstimatedSegments } from '@/composables/useEstimatedSegments';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationItemsVisibilityButton',
  setup(__props) {

const { hiddenFilter, toggleHiddenFilter } = useVisibleCalculationItems();
const route = useRoute();

const allRulesFilters = computed(() => ({
  hidden: 'all' as const,
  ruleTypes: ['calculation'],
  includeChildRules: false,
  includeSegmentRules: true,
  includeGroupRules: true,
}));

const { segmentRules: allRules } = useEstimatedSegments(allRulesFilters);

function getHiddenIcon() {
  return hiddenFilter.value === 'unhidden-only' ? 'pi-eye-slash' : 'pi-eye';
}

function getHiddenCount() {
  if (!allRules.value) return 0;

  const segmentIdParam = route.params.segmentId;
  const groupIdParam = route.params.groupId;
  const hasSegmentScope = segmentIdParam !== undefined && segmentIdParam !== '';

  const segmentsInScope = hasSegmentScope
    ? allRules.value.filter(
        (segment) => segment.id === Number(segmentIdParam) && segment.rules.length
      )
    : allRules.value;

  const hasGroupScope = groupIdParam !== undefined && groupIdParam !== '';

  let count = 0;
  segmentsInScope.forEach((segment) => {
    const groupsInScope = hasGroupScope
      ? segment.groups.filter(
          (group) => group.id === Number(groupIdParam) && group.rules.length
        )
      : segment.groups;

    groupsInScope.forEach((group) => {
      count += group.rules.filter((rule) => (rule as any).is_hidden).length;
    });

    count += segment.rules.filter((rule) => (rule as any).is_hidden).length;
  });

  return count;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    severity: "secondary",
    text: "",
    icon: "",
    onClick: _unref(toggleHiddenFilter),
    size: "small"
  }, {
    default: _withCtx(() => [
      _createElementVNode("i", {
        class: _normalizeClass(`pi ${getHiddenIcon()}`)
      }, null, 2),
      (_unref(hiddenFilter) === 'unhidden-only')
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(getHiddenCount()) + ") ", 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClick"]))
}
}

})